import React from "react";
import { Link } from "react-router-dom";
import Container from 'react-bootstrap/Container';
import { Footer } from './headerFooter';
import "./custom.scss";

const PrivacyPolicy = () => {
  return (
    <div id="root">
        <main className='main-container'>
            <Container className='custom-container pt-3'>
                <h2>Πολιτική Απορρήτου & Προστασία Προσωπικών Δεδομένων (GDPR)</h2>
                <p className="last-updated">Τελευταία ενημέρωση: 8 Ιουνίου 2026</p>

                <h3>1. Υπεύθυνος Επεξεργασίας και Συλλογή Δεδομένων</h3>
                <p>
                  Υπεύθυνος επεξεργασίας για την εφαρμογή <strong>teachers-app.com</strong> είναι η{" "}
                  <strong>ομάδα ανάπτυξης του teachers-app.com</strong>. Για θέματα προστασίας
                  δεδομένων:{" "}
                  <strong><a href="mailto:support@teachers-app.com">support@teachers-app.com</a></strong>
                </p>
                <p>
                  Συλλέγουμε μόνο τα απολύτως απαραίτητα προσωπικά δεδομένα για τη λειτουργία της
                  υπηρεσίας. Κατά την <strong>εγγραφή</strong> ζητούνται:
                </p>
                <ul>
                    <li>Όνομα χρήστη (username)</li>
                    <li>Κωδικός πρόσβασης</li>
                    <li>Email</li>
                    <li>Εκπαιδευτικός κλάδος / ειδικότητα (π.χ. ΠΕ60, ΠΕ70)</li>
                </ul>
                <p>
                  Επιπλέον, στη βάση δεδομένων μπορεί να αποθηκεύονται: κατάσταση επαλήθευσης
                  λογαριασμού, κατάσταση <strong>premium</strong> πρόσβασης, μετρητής χρήσης του
                  εργαλείου predict, καθώς και χρονικές σημάνσεις αποδοχής των{" "}
                  <Link to="/terms-of-use" className="footer-links">όρων χρήσης</Link> και της
                  παρούσας πολιτικής.
                </p>
                <p>
                  Τα δεδομένα χρησιμοποιούνται για: δημιουργία και διαχείριση λογαριασμού,
                  αυθεντικοποίηση, παροχή των λειτουργιών της εφαρμογής, εφαρμογή ορίων
                  (π.χ. δωρεάν προσπάθειες predict), στήριξη χρηστών και βελτίωση της υπηρεσίας.
                </p>

                <h3>2. Εγγραφή, Σύνδεση και Φόρμα Επικοινωνίας</h3>
                <p>
                    Η εφαρμογή απαιτεί <strong>εγγραφή και σύνδεση</strong>. Μετά την είσοδο,
                    αποθηκεύονται στο πρόγραμμα περιήγησής σας tokens σύνδεσης (βλ. §3).
                </p>
                <p>
                    Η <strong>φόρμα επικοινωνίας</strong> (μόνο για συνδεδεμένους χρήστες) ζητά:
                </p>
                <ul>
                    <li>Όνομα και επώνυμο</li>
                    <li>Email</li>
                    <li>Θέμα και μήνυμα</li>
                </ul>
                <p>
                    Το αίτημα αποστέλλεται μέσω email στο{" "}
                    <strong><a href="mailto:support@teachers-app.com">support@teachers-app.com</a></strong>{" "}
                    μαζί με το όνομα χρήστη του λογαριασμού σας. Τα στοιχεία της φόρμας{" "}
                    <strong>δεν αποθηκεύονται</strong> σε ξεχωριστό πίνακα της βάσης δεδομένων·
                    διατηρούνται στο σύστημα email για χειρισμό του αιτήματος.
                </p>

                <h3>3. Αποθήκευση Τοπικά (localStorage)</h3>
                <p>
                    Η εφαρμογή αποθηκεύει στο <strong>localStorage</strong> του προγράμματος
                    περιήγησής σας (όχι cookies, αλλά παρόμοια λειτουργία):
                </p>
                <ul>
                    <li>Tokens σύνδεσης (<code>authToken</code>, <code>refreshToken</code>) για
                        αυθεντικοποίηση</li>
                    <li>Προτιμήσεις διεπαφής (π.χ. εμφάνιση καλωσορίσματος μετά την είσοδο)</li>
                </ul>
                <p>
                    Τα στοιχεία αυτά διαγράφονται με <strong>αποσύνδεση</strong> ή καθαρισμό
                    δεδομένων του browser. Δεν τα χρησιμοποιούμε για διαφήμιση.
                </p>

                <h3>4. Cookies και Analytics</h3>
                <p>
                    Η εφαρμογή χρησιμοποιεί την υπηρεσία <strong>Google Analytics 4</strong> (Google
                    Ireland Limited / Google LLC) μέσω του script gtag.js. Σκοπός: κατανόηση της
                    χρήσης του ιστότοπου (σελίδες που επισκέπτεστε, γεγονότα όπως εγγραφή ή
                    σύνδεση).
                </p>
                <p>
                    Κατά την εγγραφή ή σύνδεση μπορεί να αποστέλλεται στην Google ένα
                    <strong> ψευδωνυμοποιημένο αναγνωριστικό χρήστη</strong> (όχι το πραγματικό
                    όνομα χρήστη). Η Google ενδέχεται να τοποθετεί cookies τρίτων στον
                    υπολογιστή ή τη συσκευή σας.
                </p>
                <p>
                    Περισσότερα:{" "}
                    <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">
                        Πολιτική Απορρήτου Google
                    </a>
                    . Μπορείτε να περιορίσετε την παρακολούθηση μέσω{" "}
                    <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noopener noreferrer">
                        επέκτασης opt-out του Google Analytics
                    </a>{" "}
                    ή ρυθμίσεων του browser σας.
                </p>

                <h3>5. Premium, PayPal και Χρήση Predict</h3>
                <p>
                    Η εφαρμογή προσφέρει <strong>εθελοντική χορηγία</strong> μέσω{" "}
                    <strong>PayPal</strong> για ξεκλείδωμα premium πρόσβασης στο εργαλείο
                    «Εκτιμήσεις πιθανοτήτων πρόσληψης». Λεπτομέρειες στην ενότητα 6 των{" "}
                    <Link to="/terms-of-use" className="footer-links">Όρων Χρήσης</Link>.
                </p>
                <ul>
                    <li>
                        Αποθηκεύουμε αν ο λογαριασμός είναι <strong>premium</strong> (
                        <code>user_premium</code>) και πόσες δωρεάν προσπάθειες predict έχουν
                        χρησιμοποιηθεί (<code>user_requests</code>).
                    </li>
                    <li>
                        Για αποφυγή διπλής χορήγησης premium, αποθηκεύουμε το αναγνωριστικό
                        συναλλαγής PayPal (<code>paypal_donation_txns</code>) συνδεδεμένο με τον
                        λογαριασμό σας.
                    </li>
                    <li>
                        <strong>Δεν αποθηκεύουμε</strong> στοιχεία πληρωμής (π.χ. αριθμούς καρτών)·
                        η πληρωμή επεξεργάζεται αποκλειστικά από την PayPal.
                    </li>
                </ul>

                <h3>6. Αποδοχή Όρων και Πολιτικής</h3>
                <p>
                    Κατά την εγγραφή ή όταν ενημερώνονται οι όροι, ζητείται ρητή αποδοχή των{" "}
                    <Link to="/terms-of-use" className="footer-links">Όρων Χρήσης</Link> και της
                    παρούσας πολιτικής. Καταγράφουμε:
                </p>
                <ul>
                    <li>Ημερομηνία αποδοχής όρων (<code>terms_accepted_at</code>)</li>
                    <li>Έκδοση όρων που αποδεχτήκατε (<code>terms_version</code>)</li>
                    <li>Ημερομηνία αποδοχής πολιτικής απορρήτου (<code>privacy_accepted_at</code>)</li>
                </ul>
                <p>
                    Σκοπός: απόδειξη συγκατάθεσής σας και συμμόρφωση με ενημερωμένους όρους.
                    Νομική βάση: <strong>συγκατάθεση</strong> (άρθρο 6 παρ. 1 στοιχ. α΄ GDPR).
                </p>

                <h3>7. Δεδομένα στα Εργαλεία (Predict κ.λπ.)</h3>
                <p>
                    Όταν χρησιμοποιείτε εργαλεία όπως το <strong>predict</strong> (δοκιμαστική
                    έκδοση), εισάγετε φίλτρα: ειδικότητα, θέση πίνακα, περιοχές προτίμησης,
                    ημερομηνία πρόσληψης κ.λπ. Τα δεδομένα αυτά:
                </p>
                <ul>
                    <li>Επεξεργάζονται προσωρινά για τον υπολογισμό και την απόκριση του API</li>
                    <li><strong>Δεν αποθηκεύονται μόνιμα</strong> ως ιστορικό αναζητήσεών σας</li>
                    <li>Χρησιμοποιούνται αποκλειστικά για ενημερωτική/στατιστική εκτίμηση (βλ. όρους χρήσης)</li>
                </ul>

                <h3>8. Φιλοξενία και Τρίτοι Πάροχοι</h3>
                <p>
                    Τα προσωπικά σας δεδομένα <strong>δεν πωλούνται</strong> σε τρίτους. Κοινοποιούνται
                    μόνο σε επεξεργαστές που απαιτούνται για τη λειτουργία της υπηρεσίας:
                </p>
                <ul>
                    <li>
                        <strong>Namecheap</strong> — φιλοξενία (hosting) της εφαρμογής και της
                        βάσης δεδομένων
                    </li>
                    <li>
                        <strong>PayPal</strong> — επεξεργασία εθελοντικών χορηγιών (στοιχεία
                        πληρωμής, αναγνωριστικό συναλλαγής)
                    </li>
                    <li>
                        <strong>Google</strong> — στατιστική ανάλυση χρήσης (Google Analytics 4)
                    </li>
                    <li>
                        <strong>Πάροχος email (SMTP)</strong> — αποστολή email υποστήριξης και
                        επικοινωνίας
                    </li>
                </ul>
                <p>
                    Οι παραπάνω πάροχοι επεξεργάζονται δεδομένα σύμφωνα με τους δικούς τους όρους
                    και πολιτικές απορρήτου. Η κοινοποίηση γίνεται μόνο στο βαθμό που είναι
                    απαραίτητη για την παροχή της υπηρεσίας ή όπου απαιτείται νομικά.
                </p>

                <h3>9. Νομική Βάση Επεξεργασίας</h3>
                <p>Η επεξεργασία των δεδομένων σας βασίζεται σε:</p>
                <ul>
                    <li>
                        <strong>Εκτέλεση σύμβασης / παροχή υπηρεσίας</strong> (άρθρο 6 παρ. 1
                        στοιχ. β΄): λογαριασμός, σύνδεση, χρήση εργαλείων, premium όρια
                    </li>
                    <li>
                        <strong>Συγκατάθεση</strong> (άρθρο 6 παρ. 1 στοιχ. α΄): αποδοχή όρων
                        και πολιτικής, Google Analytics
                    </li>
                    <li>
                        <strong>Έννομο συμφέρον</strong> (άρθρο 6 παρ. 1 στοιχ. στ΄): ασφάλεια
                        συστήματος, πρόληψη κατάχρησης API
                    </li>
                </ul>

                <h3>10. Διάρκεια Τήρησης Δεδομένων</h3>
                <ul>
                    <li>
                        <strong>Στοιχεία λογαριασμού:</strong> όσο ο λογαριασμός παραμένει ενεργός
                    </li>
                    <li>
                        <strong>Αποδοχή όρων/απορρήτου:</strong> όσο ο λογαριασμός είναι ενεργός
                        και για το διάστημα που επιβάλλεται νομικά
                    </li>
                    <li>
                        <strong>Συναλλαγές PayPal (txn id):</strong> για αποφυγή διπλής χορήγησης
                        premium και λογιστικούς σκοπούς
                    </li>
                    <li>
                        <strong>Google Analytics:</strong> σύμφωνα με τις ρυθμίσεις διατήρησης
                        του λογαριασμού Analytics
                    </li>
                    <li>
                        <strong>Email υποστήριξης:</strong> για λογικό χρονικό διάστημα εξυπηρέτησης
                        του αιτήματος
                    </li>
                </ul>
                <p>
                    Μπορείτε οποιαδήποτε στιγμή να αιτηθείτε <strong>διαγραφή λογαριασμού</strong>{" "}
                    στο: <strong><a href="mailto:support@teachers-app.com">support@teachers-app.com</a></strong>
                </p>

                <h3>11. Μέτρα Ασφαλείας</h3>
                <p>
                    Η προστασία των δεδομένων σας είναι προτεραιότητά μας. Η εφαρμογή χρησιμοποιεί{" "}
                    <strong>SSL κρυπτογράφηση</strong> και <strong>firewalls</strong> για την
                    αποτροπή μη εξουσιοδοτημένης πρόσβασης.
                </p>

                <h3>12. Δικαιώματα Χρηστών (βάσει GDPR)</h3>
                <p>
                    Σύμφωνα με τον Γενικό Κανονισμό Προστασίας Δεδομένων (Κανονισμός ΕΕ 2016/679),
                    έχετε τα εξής δικαιώματα:
                </p>
                <ul>
                    <li>Δικαίωμα πρόσβασης στα δεδομένα σας</li>
                    <li>Δικαίωμα διόρθωσης ανακριβειών</li>
                    <li>Δικαίωμα διαγραφής (&quot;δικαίωμα στη λήθη&quot;)</li>
                    <li>Δικαίωμα περιορισμού της επεξεργασίας</li>
                    <li>Δικαίωμα εναντίωσης</li>
                    <li>Δικαίωμα φορητότητας των δεδομένων</li>
                    <li>Δικαίωμα ανάκλησης συγκατάθεσης (όπου η επεξεργασία βασίζεται σε αυτή)</li>
                </ul>
                <p>
                    Για την άσκηση οποιουδήποτε από τα παραπάνω δικαιώματα, επικοινωνήστε μαζί μας
                    στο: <strong><a href="mailto:support@teachers-app.com">support@teachers-app.com</a></strong>.
                    Έχετε επίσης δικαίωμα καταγγελίας στην Αρχή Προστασίας Δεδομένων Προσωπικού
                    Χαρακτήρα (www.dpa.gr).
                </p>

                <h3>13. Ενημερώσεις στην Πολιτική</h3>
                <p>
                    Η παρούσα πολιτική απορρήτου ενδέχεται να τροποποιείται. Για{" "}
                    <strong>ουσιώδεις αλλαγές</strong> θα καταβάλλεται προσπάθεια εύλογης
                    ειδοποίησης (π.χ. μέσω της εφαρμογής ή email) και, όπου απαιτείται,
                    <strong> επανα-αποδοχή</strong> της ενημερωμένης πολιτικής.
                </p>
                <p>
                    Οι αλλαγές δημοσιεύονται σε αυτή τη σελίδα με ενημερωμένη ημερομηνία.
                    Σχετικοί όροι χρήσης της υπηρεσίας:{" "}
                    <Link to="/terms-of-use" className="footer-links">Όροι Χρήσης</Link>.
                </p>
            </Container>
        </main>
    <Footer />
    </div>
  );
};


export default PrivacyPolicy;
